import { axiosInstance } from './axios.config.api';
import { retry } from 'rxjs/operators';
import { ContactUsModel } from '@/models/contact-us.model';

export default class ContactUsApi {
    sendContactEmail(data: ContactUsModel) {
        return axiosInstance().post('contact-us', data)
            .pipe(retry(1)).toPromise();
    }
}
